<template>
  <div class="table__rows-container">
    <div
      v-for="item in data"
      :key="item.id"
      class="table__row"
      :class="rowClass"
    >
      <!-- 1 -->
      <div>
          {{ item.id }}
      </div>

      <!-- 2 -->
      <div>
        <router-link  class="link"
                      :to="`/accounts/${item.address}`">{{ item.address }}</router-link>
      </div>

      <!-- 3 -->
      <div>
        <span>{{ item.amount }}</span>
      </div>
      <!-- 4 -->
      <div>
        <span>{{ item.ratio }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["data", "rowClass"],
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contents/shared/TableSloatRichAccount.vue